import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const STORAGE_KEY = 'getmatch-guide';

interface GuideState {
  /** Master switch for automatic tours. FieldHelp ignores it on purpose. */
  enabled: boolean;
  /** Ids of tours already completed or skipped. */
  seenTours: string[];
  setEnabled: (enabled: boolean) => void;
  markSeen: (tourId: string) => void;
  resetSeen: () => void;
}

export const useGuideStore = create<GuideState>()(
  persist(
    (set) => ({
      enabled: true,
      seenTours: [],
      setEnabled: (enabled) => set({ enabled }),
      markSeen: (tourId) =>
        set((state) =>
          state.seenTours.includes(tourId)
            ? state
            : { seenTours: [...state.seenTours, tourId] },
        ),
      resetSeen: () => set({ seenTours: [] }),
    }),
    // localStorage is persist's default storage, and the actions drop out of
    // JSON on their own, so there is nothing for a partialize to exclude.
    { name: STORAGE_KEY, version: 1 },
  ),
);
